<template>
    <div class="nevs-content" v-if="loaded">
        <div class="nevs-content-top-buttons">
            <NevsButton @click="saveClick()" class="success"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton @click="backClick" class="error"><i class="fa-solid fa-arrow-left"></i> {{
                    $LANG.Get('buttons.back')
                }}
            </NevsButton>
        </div>
        <NevsCard class="client-form">
            <NevsTextField :error="clientValidation.name" :label="$LANG.Get('fields.name') + ':'"
                           v-model="client.name"></NevsTextField>
            <NevsTextField :error="clientValidation.oib" :label="$LANG.Get('fields.oib') + ':'"
                           v-model="client.oib"></NevsTextField>
            <NevsTextField :error="clientValidation.official_email" :label="$LANG.Get('fields.officialEmail') + ':'"
                           v-model="client.official_email"></NevsTextField>
            <NevsTextField readonly :error="clientValidation.hash" :label="$LANG.Get('fields.hash') + ':'"
                           v-model="client.hash"></NevsTextField>
            <NevsTextField :error="clientValidation.api_token" :label="$LANG.Get('fields.apiToken') + ':'"
                           v-model="client.api_token"></NevsTextField>
            <NevsTextField :error="clientValidation.valid_until" :label="$LANG.Get('fields.validUntil') + ':'"
                           v-model="client.valid_until"></NevsTextField>
            <NevsSelect v-model="client.financial_status_id" :ajax="'select/financial-statuses'"
                        :label="$LANG.Get('fields.financialStatus')"></NevsSelect>
            <NevsNumberField :decimalPlaces="0" :error="clientValidation.discount" :label="$LANG.Get('fields.discount') + ':'"
                             v-model="client.discount"></NevsNumberField>
            <NevsCheckbox :label="$LANG.Get('fields.plus')" v-model="client.plus"></NevsCheckbox>
            <NevsTextField :error="clientValidation.ais_api_key" :label="$LANG.Get('fields.aisApiKey') + ':'"
                           v-model="client.ais_api_key"></NevsTextField>
            <NevsTextField :error="clientValidation.ais_account_id" :label="$LANG.Get('fields.aisAccountId') + ':'"
                           v-model="client.ais_account_id"></NevsTextField>
        </NevsCard>
        <NevsCard class="client-invoices">
            <table class="client-invoices-table">
                <thead>
                    <tr>
                        <th>{{ $LANG.Get('fields.number') }}</th>
                        <th>{{ $LANG.Get('fields.date') }}</th>
                        <th>{{ $LANG.Get('fields.amount') }}</th>
                        <th>{{ $LANG.Get('fields.financialStatus') }}</th>
                        <th>{{ $LANG.Get('fields.pdf') }}</th>
                        <th>{{ $LANG.Get('fields.email') }}</th>
                        <th>{{ $LANG.Get('fields.ignore') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(invoice, key) in client.invoices" :key="key" :class="invoiceRowClass(invoice)">
                        <td>{{ invoice.number }}</td>
                        <td>{{ invoice.date }}</td>
                        <td style="text-align: right;">{{ invoice.amount }}</td>
                        <td style="text-align: right;">{{ invoice.financial_status }}</td>
                        <td style="text-align: center;"><a :href="invoice.pdf" target="_blank"><i class="fa-solid fa-file-pdf"></i></a></td>
                        <td style="text-align: center;"><input type="checkbox" :checked="selectedInvoiceHashes.includes(invoice.hash)" @change="toggleInvoice(invoice.hash)"></td>
                        <td style="text-align: center;"><input type="checkbox" :checked="ignoredInvoiceHashes.includes(invoice.hash)" @change="toggleIgnored(invoice.hash)"></td>
                    </tr>
                </tbody>
            </table>
        </NevsCard>
    </div>
</template>

<script>
import Client from '@/models/Client.js';
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";

export default {
    name: "EntityClient",
    components: {NevsNumberField, NevsCheckbox, NevsSelect, NevsTextField, NevsButton, NevsCard},
    data() {
        return {
            loaded: false,
            client: new Client({id: this.$route.params.id}),
            clientValidation: new Client({}, true),
            changePassword: false,
            selectedInvoiceHashes: [],
            ignoredInvoiceHashes: []
        }
    },
    methods: {
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        saveClick() {
            let vm = this;
            // Optional, but when given it has to be an address we can write to.
            this.clientValidation.official_email = '';
            let officialEmail = (this.client.official_email || '').trim();
            if (officialEmail !== '' && !this.$HELPERS.CheckEmail(officialEmail)) {
                this.clientValidation.official_email = this.$LANG.Get('labels.invalidEmailAddress');
                return;
            }
            let payload = Object.assign({}, this.client);
            payload.selected_invoice_hashes = this.selectedInvoiceHashes;
            payload.ignored_invoice_hashes = this.ignoredInvoiceHashes;
            this.$API.APICall('put', 'clients/' + this.client.id, payload, (data, success) => {
                if (success) {
                    vm.$CROSS_TAB_BUS.TriggerEvent('reload-clients', {});
                    vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                    vm.backClick();
                }
            });
        },
        toggleInvoice(hash) {
            let idx = this.selectedInvoiceHashes.indexOf(hash);
            if (idx === -1) {
                this.selectedInvoiceHashes.push(hash);
            } else {
                this.selectedInvoiceHashes.splice(idx, 1);
            }
        },
        toggleIgnored(hash) {
            let idx = this.ignoredInvoiceHashes.indexOf(hash);
            if (idx === -1) {
                this.ignoredInvoiceHashes.push(hash);
            } else {
                this.ignoredInvoiceHashes.splice(idx, 1);
            }
        },
        invoiceRowClass(invoice) {
            let emailChecked = this.selectedInvoiceHashes.includes(invoice.hash);
            let ignoreChecked = this.ignoredInvoiceHashes.includes(invoice.hash);
            if (emailChecked && ignoreChecked) return 'invoice-row-orange';
            if (emailChecked && invoice.financial_status_raw <= 0) return 'invoice-row-red';
            return '';
        }
    },
    mounted() {
        this.$store.commit('selectMenu', 'clients');
        this.$store.commit('selectSubMenu', null);

        let vm = this;
        this.$API.APICall('get', 'clients/' + this.client.id, {}, (data, success) => {
            if (success) {
                if (data.client !== null) {
                    vm.client.Fill(data.client);
                    if (vm.client.selected_invoice_hashes !== null) {
                        vm.selectedInvoiceHashes = vm.client.selected_invoice_hashes;
                    } else {
                        vm.selectedInvoiceHashes = vm.client.invoices.map(inv => inv.hash);
                    }
                    vm.ignoredInvoiceHashes = vm.client.ignored_invoice_hashes ?? [];
                    vm.$store.commit('setBreadcrumbs', [
                        {
                            label: vm.$LANG.Get('modules.clients'),
                            link: '/clients'
                        },
                        {
                            label: vm.client.name,
                            link: null
                        }
                    ]);
                    vm.$nextTick(()=>{
                       vm.loaded = true;
                    });
                } else {
                    vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.serverError'), type: 'alert'});
                }
            } else {
                vm.$LOCAL_BUS.TriggerEvent('popup', {text: vm.$LANG.Get('alerts.serverError'), type: 'alert'});
            }
            vm.$nextTick(() => {
                vm.loaded = true;
            });
        });
    }
}
</script>

<style scoped>
.client-form {
    max-width: 500px;
}

.client-invoices {
    margin-top: 10px;
    width: fit-content;
}

.client-invoices-table {
    border-spacing: 0;
    border-collapse: collapse;
}

.client-invoices-table td, .client-invoices-table th {
    border: 1px solid black;
    padding: 5px;
}

.invoice-row-red td {
    background-color: #ffcccc;
}

.invoice-row-orange td {
    background-color: #ffe0b2;
}
</style>